import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { SharedUtilService } from "@app/_shared/shared-util.service";
import { EndpointService } from "@app/endpoint/endpoint.service";
import { PerformanceService } from "@app/performance/performance.service";
import { UserService } from "@app/user/user.service";
import { constants } from "@assets/data/constants";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-new-performance-jmx-upload",
  templateUrl: "./new-performance-jmx-upload.component.html",
  styleUrls: ["./new-performance-jmx-upload.component.less"],
})
export class NewPerformanceJmxUploadComponent implements OnInit {
  userForm: any;
  userProjects = [];
  files: any = [];
  locationList: any = []
  performanceRequestId: any;
  selectedProject: any;
  selectedJMXFile: any;
  rerunData: any;
  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private EndpointServices: EndpointService,
    private sharedUtilService: SharedUtilService,
    private performanceService: PerformanceService,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.titleService.setTitle("New Performance - JMX Upload");
    this.performanceRequestId = this.route.snapshot.params.id;
    this.locationList = JSON.parse(localStorage.getItem('about')).executionLocations;;
    this.setUserForm();
    if (this.performanceRequestId && this.performanceRequestId !== undefined) {
      this.loadRerunData(this.performanceRequestId);
    } else {
      this.getUserProject();
    }
   }

   loadRerunData(rerunId: any) {
    this.performanceService.rerunQueue(rerunId).subscribe(data => {
      if (data.code === 200) {
        this.rerunData = data.response;
        this.getUserProject();
        this.performanceRequestId = null;
      } else {
        this.toastr.error(data.message);
        this.router.navigate(['/performance/loadTesting/queue']);
      }
    });
  }


  setUserForm() {
    this.userForm = this.formBuilder.group({
      project: [null, Validators.required],
      JmxFile: [null, Validators.required],
      location: ['OREGON', Validators.required],
    });
  }

  getUserProject() {
    this.userService.getMyProjectList().subscribe((data) => {
      if (data.code === 200) {
        this.userProjects = data.response;
        if (this.rerunData && this.rerunData !== undefined) {
          this.selectedProject = this.userProjects.find(project => project.id === this.rerunData.projectId);
          this.fetchJMXFiles(this.selectedProject);
        }
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  submitForm() {
    if (this.userForm.status !== "INVALID") {
      var newData = {
        location: this.userForm.value.location,
      };
    }
    this.performanceService.runJMXFile(newData, this.userForm.value.project.id, this.userForm.value.JmxFile.gridFsId).subscribe(data => {
      if (data.code === 200) {
        this.toastr.success(data.message);
        this.router.navigate(['/performance/loadTesting/queue']);
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  fetchJMXFiles(data: any) {
    this.EndpointServices.getFilesByProject(data.id).subscribe((data) => {
      if (data.code === 200) {
        this.files = data.response.filter(file => file.fileName.toLowerCase().endsWith('.jmx'));
        if (this.rerunData && this.rerunData !== undefined) {
          this.selectedJMXFile = this.files.find(file => file.gridFsId === this.rerunData.jmxFileId);
          this.updateForm();
        }
      } else {
        this.files = [];
      }
    });
  }

  updateForm() {
    this.userForm.setValue({
      project: this.selectedProject,
      JmxFile: this.selectedJMXFile,
      location: this.rerunData.location
    })
  }

  onFileChanged(event) {
    const file = event.target.files[0]
    if (file == null) return;
    let formData = new FormData();
    formData.append("file0", file);
    this.sharedUtilService.openConfirmDialog(constants.saveFileConfirmation, false).then((result) => {
      if (result) {
        this.userService.uploadFile(this.userForm.value.project.id, formData, false, false, false, false, file.name).subscribe(data => {
          if (data.code == 200) {
            this.toastr.success("file uploaded successfully");
            this.fetchJMXFiles(this.userForm.value.project);
          } else {
            this.toastr.error(data.message);
          }
        });
      }
    });
  }
}
